{
  "Accept & Continue": "Accept & Continue",
  "Add Image": "Add Image",
  "Add More": "Add More",
  "Are you sure you want to leave? Your changes will be lost.": "Are you sure you want to leave? Your changes will be lost.",
  "Auto-fill Form": "Auto-fill Form",
  "Auto-fill requires you to verify your identity by obtaining a verification code at your registered email address or phone number. By selecting auto-fill, you consent to receiving a text message and email with your verification code. Message & data rates may apply.": "Auto-fill requires you to verify your identity by obtaining a verification code at your registered email address or phone number. By selecting auto-fill, you consent to receiving a text message and email with your verification code. Message & data rates may apply.",
  "Canada": "Canada",
  "Child": "Child",
  "Choose the forms below to begin entering information and submit": "Choose the forms below to begin entering information and submit",
  "City": "City",
  "Clear": "Clear",
  "Close": "Close",
  "Code verified successfully": "Code verified successfully",
  "Company Logo": "Company Logo",
  "Complete the following fields": "Complete the following fields",
  "Complete the following fields (required by HIPAA)": "Complete the following fields (required by HIPAA)",
  "Complete the following fields (required by HIPAA) to securely verify your identity": "Complete the following fields (required by HIPAA) to securely verify your identity",
  "Continue": "Continue",
  "Country": "Country",
  "Date of Birth": "Date of Birth",
  "Dependent": "Dependent",
  "Didn't receive the code?": "Didn't receive the code?",
  "Don't have access to your phone or email?": "Don't have access to your phone or email?",
  "Download Now": "Download Now",
  "Download time for your submission has expired": "Download time for your submission has expired",
  "Driver's License Number": "Driver's License Number",
  "Email Address": "Email Address",
  "Empty {{type}} section": "Empty {{type}} section",
  "English": "English",
  "Enter the following information to continue": "Enter the following information to continue",
  "Existing Patient": "Existing Patient",
  "Failed to generate the PDF!": "Failed to generate the PDF!",
  "Failed to send verification code. Please fill out form manually if problem persists.": "Failed to send verification code. Please fill out form manually if problem persists.",
  "Failed to verify code. Please fill out form manually if problem persists.": "Failed to verify code. Please fill out form manually if problem persists.",
  "File exceeds the {{limit}} limit": "File exceeds the {{limit}} limit",
  "File type not allowed. Accepted: {{types}}": "File type not allowed. Accepted: {{types}}",
  "Fill out Manually": "Fill out Manually",
  "Fill out manually": "Fill out manually",
  "First Name": "First Name",
  "Forms": "Forms",
  "Forms_one": "Forms",
  "Forms_other": "Forms",
  "Gender": "Gender",
  "Group Name": "Group Name",
  "Group No": "Group No",
  "HIPAA Compliance": "HIPAA Compliance",
  "Hello {{patientFirstName}}!": "Hello {{patientFirstName}}!",
  "Hello!": "Hello!",
  "Home Phone": "Home Phone",
  "If you need assistance, please reach out to {{officeName}}.": "If you need assistance, please reach out to {{officeName}}.",
  "Invalid file": "Invalid file",
  "Kiosk Image": "Kiosk Image",
  "Last Name": "Last Name",
  "Leave anyway": "Leave anyway",
  "Marital Status": "Marital Status",
  "Max file size: 12MB": "Max file size: 12MB",
  "Max {{limit}} images allowed": "Max {{limit}} images allowed",
  "Maximum size allowed for each file is {{size}} MB": "Maximum size allowed for each file is {{size}} MB",
  "Member ID": "Member ID",
  "Middle Name": "Middle Name",
  "Min": "Min",
  "Missing location or submission information for PDF generation!": "Missing location or submission information for PDF generation!",
  "Mobile Phone": "Mobile Phone",
  "New Patient": "New Patient",
  "Next": "Next",
  "No code received.": "No code received.",
  "No matching results found!": "No matching results found!",
  "No privacy policy found": "No privacy policy found",
  "No results found": "No results found",
  "No terms & conditions found": "No terms & conditions found",
  "No {{type}} listed": "No {{type}} listed",
  "OR": "OR",
  "OTP digit {{index}} of {{length}}": "OTP digit {{index}} of {{length}}",
  "Other": "Other",
  "Our office is experiencing some technical difficulties right now. Please contact our office to proceed further.": "Our office is experiencing some technical difficulties right now. Please contact our office to proceed further.",
  "PDF download expired": "PDF download expired",
  "Packets": "Packets",
  "Patient Information": "Patient Information",
  "Payer ID": "Payer ID",
  "Payer Name": "Payer Name",
  "Payer Name is required": "Payer Name is required",
  "Picture of {{type}}": "Picture of {{type}}",
  "Please attach the required image(s)": "Please attach the required image(s)",
  "Please contact the business if you have any questions.": "Please contact the business if you have any questions.",
  "Please enter a valid code": "Please enter a valid code",
  "Please only complete this form on a trusted device. If you're using a public device, please use caution when entering sensitive or personal information. Always close your browser window and permanently delete any file downloads when finished.": "Please only complete this form on a trusted device. If you're using a public device, please use caution when entering sensitive or personal information. Always close your browser window and permanently delete any file downloads when finished.",
  "Please resolve the file upload errors": "Please resolve the file upload errors",
  "Please select <1>New Patient</1> or <3>Existing Patient</3> to begin.": "Please select <1>New Patient</1> or <3>Existing Patient</3> to begin.",
  "Please upload at least {{count}} file(s)_one": "Please upload at least {{count}} file(s)",
  "Please upload at least {{count}} file(s)_other": "Please upload at least {{count}} file(s)",
  "Please wait for uploads to finish": "Please wait for uploads to finish",
  "Postal Code": "Postal Code",
  "Powered by": "Powered by",
  "Pre-Admission Registration Form": "Pre-Admission Registration Form",
  "Preferred Name": "Preferred Name",
  "Previous": "Previous",
  "Privacy Policy": "Privacy Policy",
  "Province": "Province",
  "Relationship to Subscriber": "Relationship to Subscriber",
  "Remove": "Remove",
  "Remove image": "Remove image",
  "Resend": "Resend",
  "Resend Code": "Resend Code",
  "Retry": "Retry",
  "SSN must be 9 digits": "SSN must be 9 digits",
  "Save time by auto-filling your information from past form submissions, or fill out the form manually.": "Save time by auto-filling your information from past form submissions, or fill out the form manually.",
  "Search payers...": "Search payers...",
  "Search...": "Search...",
  "Sec": "Sec",
  "Section {{current}} of {{total}}": "Section {{current}} of {{total}}",
  "Select": "Select",
  "Select All": "Select All",
  "Select Form": "Select Form",
  "Select Form to fill": "Select Form to fill",
  "Select Language": "Select Language",
  "Select Payer Name": "Select Payer Name",
  "Self": "Self",
  "Spanish": "Spanish",
  "Spouse": "Spouse",
  "State": "State",
  "Street Address 1": "Street Address 1",
  "Street Address 2": "Street Address 2",
  "Submit": "Submit",
  "Subscriber Date of Birth": "Subscriber Date of Birth",
  "Subscriber First Name": "Subscriber First Name",
  "Subscriber Last Name": "Subscriber Last Name",
  "Subscriber Member ID": "Subscriber Member ID",
  "Successful submission": "Successful submission",
  "Terms & Conditions": "Terms & Conditions",
  "Terms and Conditions": "Terms and Conditions",
  "Thank you for choosing {{companyName}}. Please take a moment to fill out the required information.": "Thank you for choosing {{companyName}}. Please take a moment to fill out the required information.",
  "Thank you for choosing {{companyName}}. Please take a moment to verify and fill out the required information.": "Thank you for choosing {{companyName}}. Please take a moment to verify and fill out the required information.",
  "Thank you.": "Thank you.",
  "There are no results at the time": "There are no results at the time",
  "There is more than one patient registered with this information. Please contact our office to proceed further.": "There is more than one patient registered with this information. Please contact our office to proceed further.",
  "There is no such patient registered with us. Enter the correct information or register as a new patient.": "There is no such patient registered with us. Enter the correct information or register as a new patient.",
  "This field is required": "This field is required",
  "This form includes a payment section and cannot be accessed via public links. Please contact {{officeName}} to request a unique link.": "This form includes a payment section and cannot be accessed via public links. Please contact {{officeName}} to request a unique link.",
  "This form is no longer available.": "This form is no longer available.",
  "This form link is not valid anymore. If you believe this is an error, please get in touch with our office.": "This form link is not valid anymore. If you believe this is an error, please get in touch with our office.",
  "This form no longer exists.": "This form no longer exists.",
  "Timer icon": "Timer icon",
  "To auto-fill your form, we need to validate your identity through a verification code.": "To auto-fill your form, we need to validate your identity through a verification code.",
  "To protect your privacy, this download option will time out in 2 minutes.": "To protect your privacy, this download option will time out in 2 minutes.",
  "Too many files": "Too many files",
  "US": "US",
  "Unable to Access form": "Unable to Access form",
  "Unfortunately, we cannot allow downloads beyond the specified time limit to protect your privacy.": "Unfortunately, we cannot allow downloads beyond the specified time limit to protect your privacy.",
  "Upload Image": "Upload Image",
  "Upload failed": "Upload failed",
  "Upload failed. Please try again.": "Upload failed. Please try again.",
  "Uploading...": "Uploading...",
  "Verification code sent successfully": "Verification code sent successfully",
  "Verify & Get Started": "Verify & Get Started",
  "Verify & Proceed": "Verify & Proceed",
  "Verify Identity": "Verify Identity",
  "Verifying . . .": "Verifying . . .",
  "We are unable to fetch them right now.": "We are unable to fetch them right now.",
  "We can't fetch your form.": "We can't fetch your form.",
  "We've sent a 6 digit code {{emailOrPhone}}": "We've sent a 6 digit code {{emailOrPhone}}",
  "Weave": "Weave",
  "Weave Forms": "Weave Forms",
  "WebOTP failed.": "WebOTP failed.",
  "Welcome": "Welcome",
  "Work Phone": "Work Phone",
  "You can download a PDF of the forms that you submitted just now.": "You can download a PDF of the forms that you submitted just now.",
  "You can upload at most {{count}} file(s)_one": "You can upload at most {{count}} file(s)",
  "You can upload at most {{count}} file(s)_other": "You can upload at most {{count}} file(s)",
  "You have unsaved changes": "You have unsaved changes",
  "You've submitted all the forms successfully!": "You've submitted all the forms successfully!",
  "Your form has been submitted successfully!": "Your form has been submitted successfully!",
  "Your form's trip is complete.": "Your form's trip is complete.",
  "ZIP": "ZIP",
  "ZIP Code": "ZIP Code",
  "form does not exist image": "form does not exist image",
  "form expired image": "form expired image",
  "form received image": "form received image",
  "more": "more",
  "scrollDown": "scrollDown",
  "unable to fetch form image": "unable to fetch form image",
  "us": "us",
  "{{type}} side of card": "{{type}} side of card"
}
